export default {"src":"/_next/static/media/emptyChat.a8c9953a.svg","height":163,"width":248,"blurWidth":0,"blurHeight":0};